import { useContext, useState } from "react";
import {
  useCreateInterwitchAccount,
  useUpdateInterwitchAccount,
} from "../../../../hooks/api/mutations/useTerminals";
import { cleanObject } from "../../../../helpers";
import { ToastContext } from "../../../../hooks/context";

export const useBusinessAccountForm = ({
  isEditMode = false,
  accountInfo = {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const [formData, setFormData] = useState({
    client_id: accountInfo?.client_id || "",
    client_secret: accountInfo?.client_secret || "",
    merchant_code: accountInfo?.merchant_code || "",
    merchant_name: accountInfo?.merchant_name || "",
    webhook_secret: accountInfo?.webhook_secret || "",
  });

  const { mutate: updateAccount, isLoading } = useUpdateInterwitchAccount();
  const { mutate: createAccount, isLoading: isLoadingAccount } =
    useCreateInterwitchAccount();

  const handleAccount = () => {
    if (isEditMode)
      return updateAccount(
        { data: cleanObject({ ...formData }), id: accountInfo?.id },
        {
          onSuccess: () => {
            triggerToast("Connection update successful", "success");
            closeModal();
          },
        },
      );

    createAccount(cleanObject({ ...formData }), {
      onSuccess: () => {
        triggerToast("Account connection successful", "success");
        closeModal();
      },
    });
  };

  return {
    isLoading: isLoading || isLoadingAccount,
    formData,
    setFormData,
    handleAccount,
  };
};
